/**
 * Product Values Section
 * Handles initialization and interactions for the product values section
 */

class ProductValuesSection {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Section is initialized
    // Add custom functionality here if needed
  }
}

// Initialize all product values sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-product-values"]');
  sections.forEach((section) => {
    new ProductValuesSection(section);
  });
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="w-product-values"]')) {
      new ProductValuesSection(event.target);
    }
  });
}

// Expose class globally for dynamic initialization
window.ProductValuesSection = ProductValuesSection;
